import React, { useState, useEffect } from 'react';
import Slider from 'rc-slider';
import styles from '../../../../searchV2.scss';

const DistanceSlider = ({ distance, handleDistanceChange }) => {
    const MAX_DISTANCE = 200;
    const MIN_DISTANCE = 5;
    const [localDistance, setLocalDistance] = useState(distance || MAX_DISTANCE);

    useEffect(() => {
        if (!!distance && distance !== localDistance) {
            setLocalDistance(distance);
        }
    }, [distance]);

    const marks = {
        5: '5',
        25: '25',
        50: '50',
        75: '75',
        100: '100',
        125: '125',
        150: '150',
        175: '175',
        200: '200',
    };

    const getValue = (distanceValue) => {
        if (typeof distanceValue === 'string') {
            return parseInt(distanceValue);
        }
        return distanceValue;
    };

    const getDisplayValue = (distanceValue) => {
        const numValue = getValue(distanceValue);
        return `${numValue} Miles`;
    };

    const handleSliderChange = (val) => {
        setLocalDistance(val);
    };

    const handleSliderAfterChange = (val) => {
        const distanceString = `${val}`;
        handleDistanceChange(distanceString);
    };

    return (
        <div className={styles.distanceSliderContainer}>
            <div className={styles.distanceHeader}>
                <span className={styles.distanceLabel}>Distance</span>
                <span className={styles.distanceValue}>{getDisplayValue(localDistance)}</span>
            </div>
            <div className={`${styles.distanceSliderWrapper} distance-slider`}>
                <Slider
                    step={null}
                    marks={marks}
                    defaultValue={MAX_DISTANCE}
                    value={getValue(localDistance)}
                    onChange={handleSliderChange}
                    onAfterChange={handleSliderAfterChange}
                    min={MIN_DISTANCE}
                    max={MAX_DISTANCE}
                />
            </div>
        </div>
    );
};

export default DistanceSlider;
